<template>
    <AppHeader fixed>
        <SidebarToggler
            class="d-lg-none"
            display="md"
            mobile
            ref="sbtoggle"
            :defaultOpen="false"
        />

        <b-link class="navbar-brand" to="#" v-if="false">
            <img
                class="navbar-brand-full"
                src="/img/brand/ikomm-logo.svg"
                width="120"
                height="40"
                alt="Logo"
            />
            <img
                class="navbar-brand-minimized"
                src="/img/brand/ikomm-logo.svg"
                width="30"
                height="30"
                alt="Logo"
            />
        </b-link>

        <div style="margin-left: 10px;">
            <SearchInput />
        </div>

        <b-navbar-nav class="ml-auto">
            <LocaleDropdown />
            <DefaultHeaderDropdownAccnt />
        </b-navbar-nav>
    </AppHeader>
</template>

<script>
import SearchInput from '@/components/SearchInput'

import { Header as AppHeader, SidebarToggler } from '@coreui/vue'

import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import LocaleDropdown from './LocaleDropdown'

export default {
    components: {
        AppHeader,
        DefaultHeaderDropdownAccnt,
        SidebarToggler,
        SearchInput,
        LocaleDropdown,
    },
    methods: {},
    created() {},
}
</script>
